import React, { FC, ReactNode } from 'react';

import styles from './index.module.scss';

export interface IntegrationSectionProps {
    /** Section title (e.g., "Identity Provider", "Storage Systems") */
    title: string;
    /** Integration cards to display */
    children: ReactNode;
}

/**
 * Section component for grouping integrations by category.
 * Displays a title on the left and card grid on the right.
 */
const IntegrationSection: FC<IntegrationSectionProps> = ({
    title,
    children,
}) => (
    <div className={styles.integrationSection}>
        <div className={styles.titleContainer}>
            <span className={styles.title}>{title}</span>
        </div>
        <div className={styles.cardsContainer}>
            {children}
        </div>
    </div>
);

export default IntegrationSection;

